/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { Constants } from '../../../../core/constants';
import { PCSettings } from '../../../../core/entities';
import { ServicesClientImpl } from '../../../../core/interactors';
import { showPCScreen } from '../../../screens/screens.reducers';
import {
    setHideAdultContentSettingHighlightPositionAction,
    setHideAdultContentStateAction,
} from '../hideadultcontent.actions';

export const onKeyBackHideAdultContentSettings = () => (dispatch: Function) => {
    dispatch(showPCScreen());
};

export const onKeyDownHideAdultContentSettings = () => (dispatch: Function, getState: Function) => {
    const { verticalPosition, verticalLimit } = getState().hideAdultContent;
    const newVerticalPosition = verticalPosition + 1;
    if (newVerticalPosition < verticalLimit) {
        dispatch(setHideAdultContentSettingHighlightPositionAction(newVerticalPosition, true));
    }
};

export const onKeyOkHideAdultContentSettings = () => (dispatch: Function, getState: Function) => {
    const { verticalPosition } = getState().hideAdultContent;
    const services = new ServicesClientImpl();

    // verticalPosition 0 indicates Hide adult content.
    const isHideAdultContentSelected: boolean = verticalPosition === 0;
    const hideAdultContentStoredState: boolean = services.isPCHideAdultContentEnabled();

    if (isHideAdultContentSelected !== hideAdultContentStoredState) {
        services.updatePCSetting(PCSettings.HIDE_ADULT, JSON.stringify(isHideAdultContentSelected));
        dispatch(setHideAdultContentStateAction(isHideAdultContentSelected));
    }
    dispatch(onKeyBackHideAdultContentSettings());
};

export const onKeyUpHideAdultContentSettings = () => (dispatch: Function, getState: Function) => {
    const { verticalPosition } = getState().hideAdultContent;
    if (verticalPosition > 0) {
        const newVerticalPosition = verticalPosition - 1;
        dispatch(setHideAdultContentSettingHighlightPositionAction(newVerticalPosition, true));
    }
};

export const onMouseOverHideAdultContentSettings =
    () => (dispatch: Function, getState: Function) => {
        const { value } = getState().inputFactory;
        const menuItems = value.split('-');
        const focusItemIndex = Number(menuItems[0]);
        if (Number.isNaN(focusItemIndex)) return;
        dispatch(setHideAdultContentSettingHighlightPositionAction(focusItemIndex, true));
    };

export const onMouseOutHideAdultContentSettings =
    () => (dispatch: Function, getState: Function) => {
        const { value } = getState().inputFactory;
        const menuItems = value.split('-');
        const focusItemIndex = Number(menuItems[0]);
        if (Number.isNaN(focusItemIndex)) return;
        dispatch(setHideAdultContentSettingHighlightPositionAction(focusItemIndex, false));
    };

export const onMouseClickHideAdultContentSettings =
    () => (dispatch: Function, getState: Function) => {
        const { value } = getState().inputFactory;

        if (value === Constants.VIDEO_PLAYER_UI_ID) return;

        dispatch(onKeyOkHideAdultContentSettings());
    };
